import React from "react";
import styles from "./Row.module.sass";
import Checkbox from "../../../../components/Checkbox";

const Row = ({
  product,
  variants,
  isAllSelected,
  isPartiallySelected,
  onProductCheck,
  onVariantCheck,
  selectedVariants,
}) => {
  return (
    <div className={styles.rowWrapper}>
      {/* Product Row */}
      <div className={styles.row}>
        <div className={styles.col}>
          <Checkbox
            className={`${styles.checkbox} ${
              isPartiallySelected ? styles.partial : ""
            }`}
            value={isAllSelected}
            onChange={onProductCheck}
          />
        </div>
        <div className={styles.col}>
          <div className={styles.productInfo}>
            {product?.ProductImage?.length > 0 && (
              <img
                src={product.ProductImage[0].src}
                alt={product.title}
                className={styles.image}
              />
            )}
            <div>
              <div className={styles.name}>{product.title}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Variants Rows */}
      {variants?.map((variant) => {
        // Find corresponding image if available
        const variantImage = product.ProductImage.find(
          (img) => img.image_id === variant.image_id
        );

        return (
          <div className={`${styles.row} ${styles.innerRow}`} key={variant.id}>
            <div className={styles.col}>
              <Checkbox
                className={styles.checkbox}
                value={selectedVariants.includes(variant.id)}
                onChange={() => onVariantCheck(variant.id)}
              />
            </div>
            <div className={styles.col}>
              <div className={styles.variantInfo}>
                {/* {variantImage && (
                  <img
                    src={variantImage.src}
                    alt={variant.title}
                    className={styles.image}
                  />
                )} */}
                <div className={styles.variantName}>{variant.title}</div>
              </div>
            </div>
            <div className={styles.col}>
              <div className={styles.colPrice}>{variant.price}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Row;
